import { internal_cloneResource } from '../resource/resource.internal.mjs';
import '@rdfjs/data-model';
import '../rdf.internal.mjs';
import 'uuid';

//
function setMockAclUrl(resource, aclUrl) {
    const resourceWithAclUrl = Object.assign(internal_cloneResource(resource), {
        internal_resourceInfo: {
            ...resource.internal_resourceInfo,
            aclUrl,
        },
    });
    return resourceWithAclUrl;
}

export { setMockAclUrl };
